// 添加样式依赖
import '@/common/css/index.scss';
import './index.scss';
import 'animate.css';
// 添加js依赖更新
// import $ from 'zepto-webpack';
// console.log($);
